import { render, staticRenderFns } from "./ClienteManter.vue?vue&type=template&id=3e744c02&"
import script from "./ClienteManter.vue?vue&type=script&lang=js&"
export * from "./ClienteManter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports